import { useLoaderData } from 'react-router';

import { QueryClient } from '@tanstack/react-query';

import { all } from '../react-query/key-fn';

export const allLoader = (queryClient: QueryClient) => async () => {
  return queryClient.ensureQueryData(all());
};

export const useFromLoader = () =>
  useLoaderData<ReturnType<typeof allLoader>>();
